import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { UserRegisterationComponent } from './user-registeration/user-registeration.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DxLoadIndicatorModule, DxScrollViewModule } from 'devextreme-angular';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';



@NgModule({
  declarations: [
    LoginComponent,
    UserRegisterationComponent,
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    NgxExtendedPdfViewerModule,
    DxScrollViewModule,
    DxLoadIndicatorModule
  ]
})
export class AuthModule { }
